module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/check-29edbb10.png";